/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import {Action} from "./action";
import {BaseInstance} from "./base-instance";
import {LocationInstance} from "./location-instance";
import {Rule} from "./rule";
import {ZoneInstance} from "./zone-instance";

export class ActionInstance extends BaseInstance {
  action: Action;
  rule: Rule;
  instanceUuid: string;
  target: string;
  targetType: TargetType;
  locations: LocationInstance[];
  zones: ZoneInstance[];
}

export enum TargetType {
  EVENT = "EVENT",
  ANTENNA = "ANTENNA",
  ANTENNA_INSTANCE = "ANTENNA_INSTANCE",
  ASSET = "ASSET",
  TAG = "TAG",
  LOCATION = "LOCATION",
  LOCATION_INSTANCE = "LOCATION_INSTANCE",
  OBJECT = "OBJECT",
  OBJECT_INSTANCE = "OBJECT_INSTANCE",
  READER = "READER",
  READER_INSTANCE = "READER_INSTANCE"
}
